import classes from "./LocationItemGroup.module.css";
import cityIcon from "src/assets/img/cityIcon.png";

export function PopularCityItem({ item, onSelectCity }) {
  const handleSelect = () => {
    onSelectCity({
      city: item.city,
      iata: item.cityIata,
      cityIata: item.cityIata,
      names: [], //FIXME: get and pass localized names
    });
  };

  return (
    <li
      key={item.city}
      tabIndex="0"
      className={classes.cityItem}
      onKeyDown={(e) => e.key === "Enter" && handleSelect()}
      onClick={handleSelect}>
      <div className={classes.row}>
        <img height={18} alt="" src={cityIcon} />
        <p>{item.localizedCity + ", " + item.localizedCountry}</p>
      </div>
    </li>
  );
}
